/* SLIDE 39 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "shared/components/SearchBar";

const PakingSettlementPage = () => {
  const navigate = useNavigate();
  const data = [
    {
      parkingName: "주차장명",
      managementID: "01-002",
      registrationDate: "2024-01-05",
    },
    {
      parkingName: "주차장명",
      managementID: "01-002",
      registrationDate: "2024-01-05",
    },
    {
      parkingName: "주차장명",
      managementID: "01-002",
      registrationDate: "2024-01-05",
    },
  ];

  const handleRowClick = () => {
    navigate("/parking_detail_settlement");
  };
  return (
    <div className="schedule-management-container pb-20">
      <SearchBar placeholder="주차장명 또는 관리번호로 검색 ..." />
      <div className="htContent">
        <div className="data-table">
          <div className="table-labels" style={{ gridTemplateColumns: "1fr 1fr 1fr", height: "38px" }} >
            <span>주차장명</span>
            <span>관리번호</span>
            <span>등록일자</span>
          </div>
          <div className="table-labels-rows">
            {data.map((row, index) => (
              <div className="filter-table" style={{ gridTemplateColumns: "1fr 1fr 1fr" }} key={index} onClick={handleRowClick}>
                <span>{row.parkingName}</span>
                <span>{row.managementID}</span>
                <span>{row.registrationDate}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
};

export default PakingSettlementPage;
